import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=city&instance=${instance}`
    }
    
    return [{
        instance: instance,
        pageLayout: 'tabs_small',
        pageTitle: '华美年度调查',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        icons: [
            {
                name: '华美年度调查',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/华美顾问/华美服务/数据服务/年度调查'),
                path: "华美服务",
                instance:instance,
            },
        ]
    }]
}